import { GlobalState } from '../reducers';
import { MC } from '../../services/utils/types';

export const getMC = (uri: string | null) => (state: GlobalState): MC | null => {
    if (!uri) return null;
    const filters = state.resources.mcs.filter((mc: MC) => mc['@id'] === uri);
    return filters.length > 0 ? filters[0] : null;
};
